import { useMutation } from '@tanstack/react-query';
import { updateUserLocation } from '@nomiss/services';

export function useUpdateUserLocation() {
  return useMutation({
    mutationFn: (input: { latitude: number; longitude: number }) =>
      updateUserLocation(input),
  });
}
